import React from "react";
import trans from "../../../../utils";
import { InputSelect } from "../../../Helpers/Input/RefactoredInput";
import { InputDate, TextAreaInput } from "../../../Helpers/Input/Input";
import { FaTrash } from "react-icons/fa6";
import dayjs from "dayjs";
import Dropfile from "../../../Helpers/Dropzone/Dropzone";

export default function SnagOfflineFormSnagData({ formBody, addData }) {
	// Add safety check at the top
	if (!addData?.values?.snags || !Array.isArray(addData.values.snags)) {
		return null;
	}
	const severities = [
		{
			value: "MINOR",
			label: "Minor",
			description: "Small defects that do not affect functionality",
		},
		{
			value: "MAJOR",
			label: "Major",
			description: "Significant defects affecting quality or functionality",
		},
		{
			value: "CRITICAL",
			label: "Critical",
			description: "Severe defects requiring immediate attention",
		},
		{
			value: "OTHER",
			label: "Other",
			description: "Custom severity level",
		},
	];
	return (
		<div style={{ paddingInline: "16px", marginTop: "24px" }}>
			{addData.values.snags.map((i, idx) => (
				<div key={idx} className="snag-offline-data">
					<div className="snag-offline-data-title">
						<div>
							{trans("SNAG")} - {Number(idx) + 1}
						</div>{" "}
						{addData.values.snags.length > 1 && idx !== 0 && (
							<div className="snag-offline-trash">
								<FaTrash
									size={14}
									cursor="pointer"
									color="red"
									onClick={() => {
										const newSnags = [...addData.values.snags];
										newSnags.splice(idx, 1);
										addData.setFieldValue("snags", newSnags);
									}}
								/>
							</div>
						)}
					</div>
					<div className="row gy-2">
						<div className="col-lg-6">
							<InputSelect
								label="Sector"
								name={`snags[${idx}].sector`}
								id={`snags[${idx}].sector`}
								options={[
									{
										label: formBody?.snagOptions?.sectors?.[0],
										value: formBody?.snagOptions?.sectors?.[0],
									},
								]}
								value={formBody?.snagOptions?.sectors?.[0]}
								disabled={true}
							/>
						</div>
						<div className="col-lg-6">
							<InputSelect
								label="Subsystem"
								name={`snags[${idx}].subsystem`}
								id={`snags[${idx}].subsystem`}
								placeholder="Select Subsystem"
								options={
									formBody?.snagOptions?.subsystems
										? Object.entries(formBody.snagOptions.subsystems).map(
												([key, value]) => ({
													label: trans(value),
													value: key,
												}),
											)
										: []
								}
								value={addData.values.snags[idx]?.subsystem}
								onChange={(value) =>
									addData.setFieldValue(`snags[${idx}].subsystem`, value)
								}
								onBlur={(value) =>
									addData.setFieldTouched(`snags[${idx}].subsystem`, true)
								}
								errors={addData.errors?.snags?.[idx]?.subsystem}
								touched={addData.touched?.snags?.[idx]?.subsystem}
							/>
						</div>
						<div className="col-lg-6">
							<InputSelect
								label="Discipline"
								name="disciplines"
								id="disciplines"
								options={[
									{
										label: formBody?.snagOptions?.disciplines?.[0],
										value: formBody?.snagOptions?.disciplines?.[0],
									},
								]}
								value={trans(formBody?.snagOptions?.disciplines?.[0])}
								disabled={true}
							/>
						</div>
						<div className="col-lg-6">
							<InputSelect
								label="Assign to"
								name="assigned_to_id"
								id="assigned_to_id"
								placeholder="Select Assign To"
								options={
									formBody?.snagOptions?.teams?.map((i) => ({
										label: i.name,
										value: i.id,
									})) || []
								}
								value={addData.values.snags[idx]?.assigned_to_id}
								onChange={(value) =>
									addData.setFieldValue(`snags[${idx}].assigned_to_id`, value)
								}
								onBlur={(value) =>
									addData.setFieldTouched(`snags[${idx}].assigned_to_id`, true)
								}
								errors={addData.errors?.snags?.[idx]?.assigned_to_id}
								touched={addData.touched?.snags?.[idx]?.assigned_to_id}
							/>
						</div>
						<div className="col-lg-12">
							<TextAreaInput
								title={trans("Description")}
								id={`snags[${idx}].description`}
								name={`snags[${idx}].description`}
								rows={3}
								placeholder={trans("Enter description")}
								value={addData.values.snags[idx]?.description}
								onChange={(e) =>
									addData.setFieldValue(
										`snags[${idx}].description`,
										e.target.value,
									)
								}
								onBlur={(value) =>
									addData.setFieldTouched(`snags[${idx}].description`, true)
								}
								errors={addData.errors?.snags?.[idx]?.description}
								touched={addData.touched?.snags?.[idx]?.description}
							/>
						</div>
						<div className="col-lg-6">
							<InputSelect
								label="Severity"
								id={`snags[${idx}].severity`}
								name={`snags[${idx}].severity`}
								placeholder="Select Severity"
								options={severities?.map((i) => {
									return {
										label: i.label,
										value: i.value,
									};
								})}
								onChange={(value) =>
									addData.setFieldValue(`snags[${idx}].severity`, value)
								}
								onBlur={(value) =>
									addData.setFieldTouched(`snags[${idx}].severity`, true)
								}
								value={addData.values.snags[idx]?.severity}
							/>
						</div>
						<div className="col-lg-6">
							<InputDate
								title={trans("Target Date")}
								id={`snags[${idx}].target_date`}
								name={`snags[${idx}].target_date`}
								formstyle="mh-fit"
								value={addData.values.snags[idx]?.target_date}
								onChange={(value) =>
									addData.setFieldValue(
										`snags[${idx}].target_date`,
										dayjs(value).toISOString(),
									)
								}
								onBlur={(value) =>
									addData.setFieldTouched(`snags[${idx}].target_date`, true)
								}
								errors={addData.errors?.snags?.[idx]?.target_date}
								touched={addData.touched?.snags?.[idx]?.target_date}
							/>
						</div>
						<div className="col-lg-12">
							<TextAreaInput
								title={trans("Location Details")}
								id={`snags[${idx}].location_details`}
								name={`snags[${idx}].location_details`}
								rows={3}
								placeholder={trans("Enter location details")}
								value={addData.values.snags[idx]?.location_details}
								onChange={(e) =>
									addData.setFieldValue(
										`snags[${idx}].location_details`,
										e.target.value,
									)
								}
								onBlur={(value) =>
									addData.setFieldTouched(
										`snags[${idx}].location_details`,
										true,
									)
								}
								errors={addData.errors?.snags?.[idx]?.location_details}
								touched={addData.touched?.snags?.[idx]?.location_details}
							/>
						</div>
						<div className="col-lg-12">
							<Dropfile
								addData={addData}
								name={`snags[${idx}].files`}
								EditableAttachments={addData?.values?.snags[idx]?.files}
								totalsize={5}
								maxtotalsize={5 * 1024 * 1024}
								style={{ backgroundColor: "white" }}
							/>
						</div>
					</div>
				</div>
			))}
		</div>
	);
}
